import React, {useEffect, useState} from 'react'
import {Form} from "antd";

const OfferUpdateRowTotal = ({record}) => {
    const [totalPrice, setTotalPrice] = useState(0)

    useEffect(() => {
        const total = record.lineTotal
        setTotalPrice(total)
    }, [record])

    return(
        <React.Fragment>
            <Form>
                <Form.Item>
                    <span>{new Intl.NumberFormat().format(totalPrice)}</span>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateRowTotal